function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import { Component } from "react";
import uuid from "uuid";
export default class Validate extends Component {
  constructor(props) {
    super(props);
    this.checkPatternMet = this.checkPatternMet.bind(this);
    this.validationGetter = this.validationGetter.bind(this);
    this.id = uuid();
  }

  componentDidMount() {
    if (!this.shouldValidate()) return;
    this.context.registerValidate(this.validationGetter, this.id);
  }

  componentWillUnmount() {
    if (!this.shouldValidate()) return;
    this.context.unregisterValidate(this.validationGetter, this.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.required !== this.props.required) {
      if (this.props.required) {
        return this.context.registerValidate(this.validationGetter, this.id);
      }

      return this.context.unregisterValidate(this.validationGetter, this.id);
    }
  }

  checkPatternMet(pattern) {
    return this.context.checkPatternMet(this.id, pattern);
  }

  validationGetter() {
    return {
      error: this.props.error,
      patterns: this.props.patterns,
      required: this.props.required,
      value: this.props.value
    };
  }

  shouldValidate() {
    return this.props.patterns || this.props.required;
  }

  render() {
    const {
      children
    } = this.props;

    if (!this.shouldValidate()) {
      return children();
    }

    const {
      getValidity,
      checkRequiredMet
    } = this.context;
    return children(getValidity(this.id), checkRequiredMet(this.id), this.checkPatternMet);
  }

}

_defineProperty(Validate, "contextTypes", {
  getValidity: PropTypes.func,
  checkPatternMet: PropTypes.func,
  checkRequiredMet: PropTypes.func,
  registerValidate: PropTypes.func,
  unregisterValidate: PropTypes.func
});